import React, { useEffect } from 'react';
import { clientAllocate } from '@fiverr-private/experiments';
import { useIdentificationContext } from '../../IdentificationContext';
import { Experiments } from '../../../shared/constants';
import { ResetPasswordStepForm } from './ResetPasswordStepForm';

interface OnSubmitArgs {
    redirectUrl?: string;
}

export const ResetPasswordStep = () => {
    const {
        navigateToRedirectUrl,
        setRedirectUrl,
        email,
        setEmail,
        closeModal,
        inLynxesIdentificationResetPasswordRollout,
        isModal,
    } = useIdentificationContext();

    const doubleStepResetPasswordExperimentGroup = clientAllocate({
        experimentId: Experiments.LYNXES_IDENTIFICATION_RESET_PASSWORD_STEP,
        experimentType: 'guest',
        numOfGroups: 2,
        rolloutResult: inLynxesIdentificationResetPasswordRollout,
    });

    useEffect(() => {
        const cleanupOnUnmount = () => setEmail('');

        return cleanupOnUnmount;
    }, [setEmail]);

    const handleDoneClick = () => {
        if (!isModal) {
            window.location.assign('/');
            return;
        }
        closeModal?.();
    };

    const onSubmit = ({ redirectUrl }: OnSubmitArgs) => {
        if (redirectUrl) setRedirectUrl(redirectUrl);

        navigateToRedirectUrl();
    };

    return (
        <ResetPasswordStepForm
            email={email}
            doubleStepResetPasswordExperimentGroup={doubleStepResetPasswordExperimentGroup}
            handleDoneClick={handleDoneClick}
            onSubmit={onSubmit}
        />
    );
};
